import { useEffect, useState } from 'react';
import { OrganizationsApi } from '@/api/clients/organizations/organizations.api';

const SEARCH_DEBOUNCE_MS = 300;

const initialResult = {
  organizations: [],
  searchedTerm: '',
  hasError: false,
  errorMessage: '',
};

export const useSearchOrganizations = (searchTerm) => {
  const [result, setResult] = useState(initialResult);
  const [isLoading, setIsLoading] = useState(true);
  const search = searchTerm.trim();

  useEffect(() => {
    const controller = new AbortController();
    const delay = search ? SEARCH_DEBOUNCE_MS : 0;

    const timeoutId = setTimeout(async () => {
      setIsLoading(true);
      try {
        const { data } = await OrganizationsApi.getOrganizations({
          search,
          signal: controller.signal,
        });
        if (controller.signal.aborted) {
          return;
        }

        setResult(
          data?.errmsg
            ? {
                ...initialResult,
                searchedTerm: search,
                hasError: true,
                errorMessage: data.errmsg,
              }
            : {
                ...initialResult,
                organizations: data?.organizations || [],
                searchedTerm: search,
              },
        );
      } catch (error) {
        if (controller.signal.aborted) {
          return;
        }

        console.error('Error fetching organizations:', error);
        setResult({ ...initialResult, searchedTerm: search, hasError: true });
      }
      setIsLoading(false);
    }, delay);

    return () => {
      clearTimeout(timeoutId);
      controller.abort();
    };
  }, [search]);

  return {
    ...result,
    isLoading: isLoading || result.searchedTerm !== search,
  };
};
